import * as React from "react";
import { useImpersonationDialogContext } from "../ImpersonationContext";

export const Header: React.FC = () => {
  const { session } = useImpersonationDialogContext();

  const searcherName = session?.actor?.fullName || session?.fullName || "Administrator";

  return (
    <div className="px-4.5 py-2.5 bg-slate-50/50 border-b border-slate-100 flex items-center justify-between select-none shrink-0 rounded-t-2xl text-[10px] text-slate-400">
      <div className="flex items-center gap-1.5 font-bold uppercase tracking-widest">
        <span>Switch Accounts</span>
      </div>
      <span className="font-semibold text-slate-400/90 truncate max-w-[280px]" title={`Searching as ${searcherName}`}>
        Searching as <span className="font-bold text-slate-400">{searcherName}</span>
      </span>
    </div>
  );
};
